export default "__VITE_ASSET__D2PtiYrX__"